import {useMutation} from "@tanstack/react-query";
import {toast} from "sonner";

import {TOAST_CONFIG} from "@/lib/constansts";
import {useInvalidate} from "@/src/modules/core/hooks";

import {clearRequiresProfileCompletionPending} from "../lib/claim-profile-pending";
import {residentClaimService} from "../services";
import type {ResidentClaimProfileRequest} from "../types";

export default function useResidentClaimProfile() {
  const invalidateMe = useInvalidate("me");

  return useMutation({
    mutationFn: (body: ResidentClaimProfileRequest) => residentClaimService.completeProfile(body),
    onSuccess: (result) => {
      clearRequiresProfileCompletionPending();
      invalidateMe();
      toast.success(result.message || "Profile completed successfully.", TOAST_CONFIG);
    },
    retry: false,
  });
}
